<template>
  <div>
    <driver-list-add-new :is-add-new-driver-sidebar-active.sync="isAddNewDriverSidebarActive"
      :owners-options="ownersOptions" @refetch-data="refetchData" />
    <!-- Filters -->
    <drivers-list-filters :owner-filter.sync="ownerFilter" :owners-options="ownersOptions" />
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <div class="m-2">
        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..." />
              <b-button variant="primary" :to="{name: 'drivers.create'}">
                <span class="text-nowrap">{{ $t('Add Driver') }}</span>
              </b-button>

            </div>
          </b-col>
        </b-row>

      </div>

      <b-table ref="refDriverListTable" class="position-relative" :items="fetchDrivers" responsive
        :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc">

        <!-- Column: name -->

        <template #cell(name)="data">
          <b-media vertical-align="center">
            {{ data.item.name }}
          </b-media>
        </template>
        <template #cell(devices)="data" style="color:red">
          <b-badge style="margin: 0.2rem" pill variant="primary" v-for="device in data.item.devices"> {{ device.name }} </b-badge>



        </template>



        <!-- Column: owner -->
        <!-- <template #cell(ownerid)="data">
          {{ data.item.owner}}
        </template> -->


        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown class="actionIcon" variant="link" no-caret :right="$store.state.appConfig.isRTL">

            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>
            <b-dropdown-item :to="{ name: 'drivers.edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>

            <b-dropdown-item>
              <feather-icon icon="TrashIcon" @click="removeDriver(data.item.id)" />
              <span class="align-middle ml-50">{{ $t('Delete') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }}
              {{ $t('entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

            <b-pagination v-model="currentPage" :total-rows="totalDrivers" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormInvalidFeedback
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'

import useDriversList from '@/views/modules/driver/driver-list/useDriversList'
import driverStoreModule from '@/views/modules/driver/driverStoreModule'
import DriverListAddNew from '@/views/modules/driver/driver-list/DriverListAddNew'
import DriversListFilters from '@/views/modules/driver/driver-list/DriversListFilters'
import { OrbitSpinner } from 'epic-spinners'

import useHelpers from '@/views/modules/useHelpers'
export default {
  components: {
    DriversListFilters,
    DriverListAddNew,
    OrbitSpinner,
    BFormInvalidFeedback,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup(props, { root }) {
    const DRIVER_APP_STORE_MODULE_NAME = 'app_driver'

    // Register module
    if (!store.hasModule(DRIVER_APP_STORE_MODULE_NAME))
      store.registerModule(DRIVER_APP_STORE_MODULE_NAME, driverStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DRIVER_APP_STORE_MODULE_NAME))
        store.unregisterModule(DRIVER_APP_STORE_MODULE_NAME)
    })

    const { confirm, toaster } = useHelpers(root)
    const isAddNewDriverSidebarActive = ref(false)

    const ownersOptions = ref([])

    const auth = store.getters['auth/user']


    // if (auth.role === 'admin') {
    store.dispatch('app_driver/getOwners')
      .then(res => ownersOptions.value = [...res.data])
      .catch(res => console.log(res))
    // }


    const removeDriver = (id) => {
      root.$swal({
        title: root.$i18n.t("Are You Sure"),
        text: root.$i18n.t("Do you want to delete this Driver?"),
        showCancelButton: true,
        confirmButtonText: root.$i18n.t('Delete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          requestStatus.value = true
          store.dispatch('app_driver/deleteDriver', id)
            .then(_ => {
              toaster('Driver Deleted Successfully')
              refetchData()
            })
            .catch(reason => console.log(reason))
        }
      })
    }

    const {
      fetchDrivers,
      tableColumns,
      perPage,
      currentPage,
      totalDrivers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDriverListTable,
      refetchData,
      ownerFilter,

      // UI
      requestStatus,


    } = useDriversList()

    return {

      // Sidebar
      isAddNewDriverSidebarActive,
      requestStatus,
      fetchDrivers,
      tableColumns,
      perPage,
      currentPage,
      totalDrivers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDriverListTable,
      refetchData,

      ownersOptions,
      ownerFilter,

      // Filter
      avatarText,
      removeDriver

    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.actionIcon>button {
  padding: 0;
}
</style>
